import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import SkeletonCss from "react-loading-skeleton/dist/skeleton.css";
import ErrorComponent from "src/components/molecules/ErrorComponent";
import GlobalCssUrl from "src/assets/styles/global.css?url";
import TailwindCssUrl from "src/assets/styles/tailwind.css?url";
import App from "./app";
import { injectStyle, injectStylesheet } from "./shadow-dom";
import { PluginProvider } from "./contexts/pluginContext";
import { TrackingProvider } from "./contexts/trackingContext";
import { debugLog } from "./utils/debug";

export async function initApp(shadowRoot, options) {
	const cssResults = await Promise.allSettled([
		injectStylesheet(shadowRoot, TailwindCssUrl),
		injectStylesheet(shadowRoot, GlobalCssUrl),
	]);
	cssResults
		.filter((r) => r.status === "rejected")
		.forEach((r) => debugLog("Failed to load stylesheet:", r.reason));
	injectStyle(shadowRoot, SkeletonCss.toString());

	const queryClient = new QueryClient();
	const root = createRoot(shadowRoot);
	debugLog("Rendering app, options: ", options);
	root.render(
		<ErrorBoundary fallbackRender={ErrorComponent}>
			<QueryClientProvider client={queryClient}>
				<PluginProvider
					frameConfig={options.frameConfig}
					hostPageData={options.hostPageData}
					shadowRoot={shadowRoot}
				>
					<TrackingProvider>
						<App />
					</TrackingProvider>
				</PluginProvider>
			</QueryClientProvider>
		</ErrorBoundary>,
	);
}
